/*
 *   File : listing.js
 *   Author : https://evoqins.com
 *   Description : SIP listing page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { toast } from "react-toastify";
import { Modal } from 'bootstrap';

//custom components
import { BreadCrumbs, Chip, CustomTab, EmptyScreen, OverLay } from '../../Component/Other';
import { ActiveSIPCard, FilterCard, DetailPreviewCard } from '../../Component/Cards';
import { Footer } from '../../Component/Footer';
import { APIService } from '../../Service';
import { EditSIPModal, KycStatusModal, OffcanvasDetailViewModal, PortfolioFilterModal, SIPConfirmationModal } from '../../Component/Modal';
import { Pagination } from '../../Component/Pagination';

//assets
import Loader from "../../Assets/Images/coloured_loader.svg";
import EmptySIP from "../../Assets/Images/EmptyScreen/no-sip.webp";
import NextIcon from "../../Assets/Images/right-black-icon.svg";
import { _getFamilyList } from '../../Helper';
import { SectionTitle } from '../../Component/Title';
import { Icon } from '../../Component/Icon';
import { PrimaryButton, TextButton } from '../../Component/Buttons';
import { _openOffcanvasModal } from '../../Helper/function';
import { useSelector } from 'react-redux';


const BREADCRUMBS = [
    {
        label: "Home",
        path: "/"
    },
    {
        label: "Manage SIP",
    },
];

const SIP_TAB = [
    {
        id: 1,
        label: "Active"
    },
    {
        id: 2,
        label: "External SIPs"
    },
    {
        id: 3,
        label: "Executed"
    },
    {
        id: 4,
        label: "Cancelled"
    },
];

const ITEMS_PER_PAGE = 10;

const FILTER_PORTFOLIO_FOR = [
    {
        id: null,
        label: "All"
    },
    {
        id: -1,
        label: "My portfolio"
    },
];

// filters
const FILTER_INVESTMENT_TYPES = [
    {
        id: null,
        label: "All"
    },
    {
        id: "fund",
        label: "Fund"
    },
    {
        id: "basket",
        label: "Basket"
    },
];

const DEFAULT_FILTER_INVESTMENT_TYPE = {
    id: null,
    label: "All"
};

const DEFAULT_FILTER_PORTFOLIO_FOR = {
    id: -1,
    label: "My portfolio"
};


const SIPListing = () => {

    const location = useLocation();
    const applied_filters = JSON.parse(localStorage.getItem("sip_filters"));
    const navigate = useNavigate();
    const FILTER_OPTIONS_FAMILY = useSelector(store => store.Reducer.FILTER_OPTIONS_FAMILY);

    const [tabIndex, setTabIndex] = useState(applied_filters && applied_filters?.tab_index ? applied_filters.tab_index : 1);
    const [isCardView, setIsCardView] = useState(applied_filters && applied_filters?.is_card_view ? applied_filters.is_card_view : false);
    const [filterPortfolioFor, setFilterPortfolioFor] = useState(applied_filters && applied_filters?.selected_portfolio_for_filter ? applied_filters.selected_portfolio_for_filter : DEFAULT_FILTER_PORTFOLIO_FOR);
    const [filterInvestmentType, setFilterInvestmentType] = useState(applied_filters && applied_filters?.selected_investment_type_filter ? applied_filters.selected_investment_type_filter : DEFAULT_FILTER_INVESTMENT_TYPE);
    const [activeSIPList, setSIPList] = useState([]);
    const [sipCancelReasons, setSipCancelReasons] = useState([]);
    const [selectedSIP, setSelectedSIP] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showEditSIPModal, setShowEditSIPModal] = useState(false);
    const [showCancelSIPModal, setShowCancelSIPModal] = useState(false);
    const [totalPageActive, setTotalPage] = useState(0);
    const [pageNumberActive, setPageNumberActive] = useState(1);
    const [sipDetail, setSIPDetail] = useState({});
    const [totalMonthlySIPAmount, setTotalMonthlySIPAmount] = useState("₹0");
    const [toggleFilterModal, setToggleFilterModal] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);
    const [selectedFundId, setSelectedFundId] = useState("");
    const [filterOptionsPortfolioFor, setFilterOptionsPortfolioFor] = useState([]);
    const [viewMore, setViewMore] = useState(false);
    const [showSIPActions, setShowSIPActions] = useState(false);
    const [showSIPStatusModal, setShowSIPStatusModal] = useState(false);

    useEffect(() => {
        // Getting sip cancel reasons
        _getSipCancelReasons();
    }, []);

    // for filters
    useEffect(() => {
        setFilterOptionsPortfolioFor([...FILTER_PORTFOLIO_FOR, ...FILTER_OPTIONS_FAMILY])
    }, [FILTER_OPTIONS_FAMILY]);

    useEffect(() => {

        window.scrollTo({
            top: 0, behavior: 'smooth' //scroll top
        });

        if (tabIndex === 1) {
            setLoading(true);
            _getActiveLIst();
        } else if (tabIndex === 2) {
            setLoading(true);
            _getExternalList();
        } else if (tabIndex === 3) {
            setLoading(true);
            _getExecutedList();
        } else if (tabIndex === 3) {
            setLoading(true);
            _getCancelledList();
        }

        // Resetting when filters applied
        setSelectedSIP({});
        setSIPDetail({});
        setViewMore(false);
        setSelectedFundId("");

        // Saving applied filters in localstorage
        localStorage.setItem("sip_filters", JSON.stringify({
            "is_card_view": isCardView,
            "tab_index": tabIndex,
            "selected_portfolio_for_filter": filterPortfolioFor,
            "selected_investment_type_filter": filterInvestmentType,
        }));

    }, [tabIndex, pageNumberActive, filterPortfolioFor, filterInvestmentType]);

    useEffect(() => {

        // Removing backdrop form UI when user goes back in history while filter modals opened
        window.addEventListener('popstate', function () {
            if (showEditSIPModal === true) {
                setShowEditSIPModal(false);
            };

            if (showCancelSIPModal === true) {
                setShowCancelSIPModal(false);
            };
        });

    }, [showEditSIPModal, showCancelSIPModal]);

    useEffect(() => {

        if (showEditSIPModal) {
            let edit_sip = new Modal(document.getElementById('edit-sip-modal'));
            edit_sip.show();
        };

    }, [showEditSIPModal]);

    useEffect(() => {

        if (showCancelSIPModal) {
            let confirm_modal = new Modal(document.getElementById('sip-confirmation-modal'));
            confirm_modal.show();
        };

    }, [showCancelSIPModal]);

    useEffect(() => {

        if (showSIPStatusModal) {
            let status_modal = new Modal(document.getElementById('kyc-status-modal'));
            status_modal.show();
        };

    }, [showSIPStatusModal]);

    //handle tab change
    const _handleTabChange = (id) => {
        setTabIndex(id);
        setPageNumberActive(1);
    };

    // handle open cancel confirm modal 
    const _handleCancelModal = () => {
        setShowCancelSIPModal(true);
        setShowSIPActions(false);
    };

    //handle modal close
    const _handleCloseConfirmModal = () => {
        var button = document.getElementById("sip-confirmation-close");
        button.click();
    };

    // handle delete active sip
    const _handleCancelActiveSIP = (cancel_reason) => {
        // API
        _cancelSIP(cancel_reason.id);
    };

    // handle edit modal
    const _handleEditSIPModal = () => {
        setShowEditSIPModal(true);
        setShowSIPActions(false);
        // setData(data)
    };

    // handle trigger the change
    const _handleShowStatusModal = () => {
        setShowEditSIPModal(false);
        setShowSIPStatusModal("EDIT");
    };

    const _handlePaginationActive = (new_start_limit) => {
        const selected_page = Math.floor(new_start_limit / ITEMS_PER_PAGE) + 1;
        setPageNumberActive(selected_page);
    };

    //handle toggle filter modal
    const _handleToggleFilter = () => {
        setToggleFilterModal(status => !status);
    };

    const _handleCloseFilterModal = () => {
        setToggleFilterModal(false);
    };

    const _handleApplyFilters = (selected_portfolio_for, selected_investment_type, status) => {
        if (status == true) {
            setFilterPortfolioFor({ ...selected_portfolio_for });
            setFilterInvestmentType({ ...selected_investment_type });
            // setIsDataLoading(true);
        }
        setToggleFilterModal(false);
    };

    const _handlePortfolioFilterModal = () => {
        setToggleFilterModal(status => status == false ? true : false);
    };

    const _handleChangeSIPListView = () => {
        setIsCardView(prev => !prev);
    };

    const _handleSelectSIP = (selected) => {

        if (selectedSIP?.sip_id !== selected.sip_id) {
            setSelectedSIP(selected);
            setDataLoading(true);
            setSelectedFundId("");
            setViewMore(false);
            // API call
            _getSIPDetails(selected.sip_id);
        } else {
            if (selectedSIP?.sip_id) {
                _openOffcanvasModal();
            }
        }
    };

    const _handleShowFundDetail = (id) => {
        if (selectedFundId === id) {
            setSelectedFundId("");
        } else {
            setSelectedFundId(id);
        }
    };

    const _handleToggleViewMore = () => {
        setViewMore(!viewMore);
    };

    const _handleToggleSIPActions = () => {
        setShowSIPActions(false);
    };

    const _handleCloseStatusModal = () => {
        setShowSIPStatusModal(false);
        // Updating list 
        setLoading(true);
        _getActiveLIst();
    };


    const _handleNavigateToOrders = (order_id) => {
        navigate("/orders", {
            state: {
                order_id,
            }
        });
        // Setting filters for orders navigation to override previous filters
        localStorage.setItem("order_filters", JSON.stringify({
            "filter_by_order_for": filterPortfolioFor,
            "tab_index": selectedSIP.type === "Fund" ? 1 : 3, // 1  - Funds. 3 - Basket,,
        }));

    };


    //API- sip active list
    const _getActiveLIst = () => {
        let api_version = 2;
        let is_post = true;
        let url = 'sip/active-list';
        let data = {
            "page_num": pageNumberActive,
            "page_size": ITEMS_PER_PAGE,
            "filter_type": filterInvestmentType?.id,
            "family_detail_id": filterPortfolioFor?.id
        };

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {
                setSIPList(response.data.sips);
                setTotalPage(Math.ceil(response.data.total_sips / ITEMS_PER_PAGE));
                setTotalMonthlySIPAmount(response.data?.total_amount_text || "₹0");

            } else {
                setSIPList([]);
            }
            setLoading(false);
        });
    };

    //API- sip active list
    const _getExternalList = () => {
        let api_version = 2;
        let is_post = true;
        let url = 'sip/external-list';
        let data = {
            "page_num": pageNumberActive,
            "page_size": ITEMS_PER_PAGE,
            // "filter_type": filterInvestmentType?.id,
            "family_detail_id": filterPortfolioFor?.id
        };

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {
                setSIPList(response.data.sips);
                setTotalPage(Math.ceil(response.data.total_sips / ITEMS_PER_PAGE));
                setTotalMonthlySIPAmount(response.data?.total_amount_text || "₹0");
            } else {
                setSIPList([]);
                setTotalMonthlySIPAmount("₹0");
            }
            setLoading(false);
        });
    };

    //API- sip executed list
    const _getExecutedList = () => {
        let api_version = 2;
        let is_post = true;
        let url = 'sip/processed-list';
        let data = {
            "page_num": pageNumberActive,
            "page_size": ITEMS_PER_PAGE,
            "filter_type": filterInvestmentType?.id,
            "family_detail_id": filterPortfolioFor?.id
        };

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {
                setSIPList(response.data.sips);
                setTotalPage(Math.ceil(response.data.total_sips / ITEMS_PER_PAGE));
            } else {
                setSIPList([]);
            }
            setLoading(false);
        });
    };

    //API- sip cancelled list
    const _getCancelledList = () => {
        let api_version = 2;
        let is_post = true;
        let url = 'sip/cancelled-list';
        let data = {
            "page_num": pageNumberActive,
            "page_size": ITEMS_PER_PAGE,
            "filter_type": filterInvestmentType?.id,
            "family_detail_id": filterPortfolioFor?.id
        };

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {
                setSIPList(response.data.sips);
                setTotalPage(Math.ceil(response.data.total_sips / ITEMS_PER_PAGE));
            } else {
                setSIPList([]);
            }
            setLoading(false);
        });
    };

    //API- Cancel SIP
    const _cancelSIP = (cancellation_reason_id) => {
        let api_version = 2;
        let is_post = true;
        let url = 'sip/cancel';
        let data = {
            "sip_id": selectedSIP.sip_id,
            "cancellation_reason_id": cancellation_reason_id,
        };

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {
                setLoading(true);
                _handleCloseConfirmModal(); //modal close
                _getActiveLIst();
                _getCancelledList();
                setShowSIPStatusModal("CANCEL");
            } else {
                toast.dismiss();
                toast.error(response.message, { className: "e-toast", });
            }
        });
    };

    //API- Cancel SIP Reasons
    const _getSipCancelReasons = () => {
        let is_post = false;
        let url = 'sip/cancel-reason';

        APIService(is_post, url).then((response) => {
            if (response.status_code === 200) {
                let cancel_reason = response.data.map((data) => {
                    const { id, reason } = data;
                    return { id, name: reason }
                })
                setSipCancelReasons(cancel_reason);
            }
        });
    };


    //API- sip active list
    const _getSIPDetails = (sip_id) => {
        let api_version = 2;
        let is_post = true;
        let url = 'sip/detail';
        let data = {
            sip_id
        };

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {
                setSIPDetail(response.data);

                // Scrolling to view
                if (document.querySelector("#detailed-fund-view")) {
                    let detailed_card_wrapper = document.querySelector("#detailed-fund-view");
                    detailed_card_wrapper.scrollIntoView({ behavior: "smooth", block: "start" })
                }

                if (window.innerWidth < 768) {
                    _openOffcanvasModal();
                }

            } else {
                setSelectedSIP({});
                setSIPDetail({});
                toast.dismiss();
                toast.error(response.message);
            }
            setDataLoading(false);
        });
    };



    // *********** Inner Components ***************//
    const TimelineCard = ({ data, dataLength, index, type }) => {
        return (
            <div className='d-flex flex-column align-items-start' key={index}>
                <div className="d-flex gap-12px align-items-center">
                    <Icon icon={data.status === "FAILED" ? "status-failed" : data.status === "SUCCESS" ? "status-success" : "status-pending"}
                        className="w-32px width-24px-res" />
                    <div>
                        <p className={`d-flex align-items-center gap-1 e-text-onyx e-font-12-res e-font-14 e-primary-font-inter e-font-weight-400 line-height-20px mb-0`}>
                            {data.full_date || data.label}
                            {/* {
                                type === 2 &&
                                <Icon icon={"arrow-right-allocation"}
                                    className="hover-arrow"
                                    size={12} />
                            } */}
                        </p>
                        {
                            type === 2 ?
                                <span className='e-text-bold-grey e-font-10-res e-font-12 e-primary-font-inter e-font-weight-400 line-height-14px'>
                                    {data.value}
                                </span>
                                :
                                <span className={`${data.view_order_available ? "text-decoration-hover-underline cursor-pointer" : "opacity-50"} e-text-egyptian-blue    e-font-10-res e-font-12 e-primary-font-inter e-font-weight-400 line-height-14px`}
                                    onClick={() => _handleNavigateToOrders(data.order_id)}>
                                    View order
                                </span>
                        }

                    </div>
                </div>
                {
                    dataLength > 1 && index !== dataLength - 1 &&
                    <img src={require("../../Assets/Images/vertical-dashed-line.svg").default}
                        className="object-fit-contain img-fluid margin-10px-start-res ms-sm-3 margin-4px-bottom"
                        draggable="false"
                        alt="vertical-dashed-line" />
                }
            </div>
        )
    };

    const DetailsViewCard = () => {
        return (
            <>
                {
                    dataLoading ?
                        <div className="e-border-1px-white-marble e-border-radius-24 p-3 pt-5 text-center pb-5" >
                            <img src={Loader}
                                draggable="false"
                                alt="loader" />
                        </div>
                        :
                        selectedSIP?.name ?
                            sipDetail.type === "Fund" ?
                                <div className='e-border-1px-white-marble e-border-radius-24 p-3'>
                                    <div className="e-bg-cultured e-border-radius-16 padding-12px-all mb-3">
                                        <div className={`d-flex gap-2`}>
                                            <img src={sipDetail.icon}
                                                width={32}
                                                height={32}
                                                className="object-fit-contain e-border-radius-8 e-bg-white p-1"
                                                draggable="false"
                                                alt="fund image" />
                                            <h3 className="e-text-charleston-green e-font-10 e-alt-font-poppins e-font-weight-400 line-height-14px margin-12px-bottom mb-0">
                                                {sipDetail.name}
                                            </h3>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <Chip type={2} name={sipDetail.status} className={sipDetail.is_active ? "e-text-persian-green e-border-1px-persian-green" : "e-border-1px-manhattan-red e-text-manhattan-red"} />
                                            {
                                                selectedSIP.show_detail && tabIndex === 1 &&
                                                <div className="position-relative">
                                                    <div className="d-inline-block" onClick={() => setShowSIPActions(true)}>
                                                        <img src={require("../../Assets/Images/3-dots.svg").default}
                                                            alt="3 dots menu"
                                                            className='cursor-pointer'
                                                            width={16}
                                                            height={16}
                                                            draggable="false"
                                                            onClick={() => { }} />
                                                    </div>
                                                    {
                                                        showSIPActions &&
                                                        <>
                                                            <OverLay isOpen={showSIPActions} onClose={_handleToggleSIPActions} />
                                                            <div className="d-flex flex-column gap-3 z-index-99 position-absolute top-100 end-0 e-bg-white e-border-radius-16 p-3">
                                                                <span className='d-flex gap-2 align-items-center  text-nowrap cursor-pointer me-5 pe-5 e-text-charleston-green e-font-12 e-alt-font-poppins e-font-weight-500 line-height-20px'
                                                                    onClick={_handleEditSIPModal}>
                                                                    <Icon icon={"edit-sip"} size={18} />
                                                                    Edit SIP
                                                                </span>
                                                                <span className='d-flex gap-2 align-items-center  text-nowrap cursor-pointer me-5 pe-5 e-text-charleston-green e-font-12 e-alt-font-poppins e-font-weight-500 line-height-20px'
                                                                    onClick={_handleCancelModal}>
                                                                    <Icon icon={"cancel-sip"} size={18} />
                                                                    Cancel SIP
                                                                </span>
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                            }
                                        </div>

                                        {
                                            sipDetail.is_active === false &&
                                            <>
                                                <div className="d-flex flex-column gap-12px margin-12px-bottom mt-3">
                                                    <div className="d-flex justify-content-between align-items-start">
                                                        <span className="e-text-onyx  e-primary-font-inter  e-font-12 e-font-weight-400 line-height-20px">
                                                            Total Invested
                                                        </span>
                                                        <span className="e-text-eerie-black e-primary-font-inter  e-font-12 e-font-weight-600 line-height-22px">
                                                            {sipDetail.amount_text}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-start">
                                                        <span className="e-text-onyx  e-primary-font-inter  e-font-12 e-font-weight-400 line-height-20px">
                                                            Units Purchased
                                                        </span>
                                                        <span className="e-text-eerie-black e-primary-font-inter  e-font-12 e-font-weight-600 line-height-22px">
                                                            {selectedSIP.units}
                                                        </span>
                                                    </div>
                                                </div>
                                                <p className="e-border-radius-18 padding-12px-lr  padding-2px-tb e-bg-white-marble e-text-html-css-gray  e-primary-font-inter  e-font-12 e-font-weight-500 line-height-20px mb-0">
                                                    Showing amount and units purchased via this SIP
                                                </p>
                                            </>
                                        }

                                        {
                                            sipDetail.status === "Cancellation in progress" &&
                                            <>
                                                <p className='mt-3 e-text-charleston-green  e-primary-font-inter  e-font-10 e-font-weight-400 line-height-16px margin-12px-bottom'>
                                                    Your SIP cancellation is being processed, If this was a mistake, you can revert it below.
                                                </p>

                                                <p className="e-border-radius-18 padding-12px-lr  padding-2px-tb e-bg-white-marble e-text-html-css-gray  e-primary-font-inter  e-font-12 e-font-weight-500 line-height-20px margin-12px-bottom">
                                                    Showing amount and units purchased via this SIP
                                                </p>

                                                <PrimaryButton name="Undo Cancellation"
                                                    className="col-7 e-font-12 padding-12px-tb e-border-radius-10"
                                                    onPress={() => { }} />
                                            </>
                                        }
                                    </div>

                                    {
                                        sipDetail.is_active === false &&
                                        <p className="mt-3 e-border-radius-4 px-2 py-2 e-bg-digital-lavender e-text-charleston-green e-primary-font-inter  e-font-10 e-font-weight-400 line-height-16px mb-0">
                                            Your SIP has been stopped and no further payments will be deducted. All your past investments remain active and will continue to grow.
                                        </p>
                                    }

                                    {/* Upcoming SIP */}
                                    {
                                        sipDetail.is_active &&
                                        <div>
                                            <SectionTitle title="Upcoming SIPs"
                                                fontFamily="e-primary-font-inter  e-text-eerie-black mb-2"
                                                fontSize="e-font-14" />

                                            <div className="d-flex gap-2 align-items-center">
                                                <Icon icon={"calendar-sip"}
                                                    size={24} />
                                                <span className='e-text-onyx e-font-12-res e-font-14 e-primary-font-inter e-font-weight-400 line-height-20px mb-0'>
                                                    {sipDetail?.upcoming_sip?.full_date || '-'}
                                                </span>
                                            </div>
                                        </div>
                                    }


                                    {/* Transaction status */}
                                    {
                                        tabIndex === 3 && sipDetail.fund_details[0]?.fund_timeline?.length !== 0 &&
                                        <div className='e-border-top-1px-sparkling-silver mt-3 pt-3'>
                                            <SectionTitle title="Transaction status"
                                                fontFamily="e-primary-font-inter  e-text-eerie-black mb-3"
                                                fontSize="e-font-14" />

                                            {
                                                (sipDetail.fund_details[0]?.fund_timeline || []).map((item, index) => (
                                                    <TimelineCard type={2}
                                                        data={item}
                                                        index={index}
                                                        dataLength={sipDetail.fund_details[0]?.fund_timeline.length} />
                                                ))
                                            }
                                        </div>
                                    }





                                    {/* Previous SIP installments */}
                                    {
                                        tabIndex !== 2 && (sipDetail.previous_installments && sipDetail.previous_installments?.length) > 0 &&
                                        <div className="mt-3">
                                            <SectionTitle title="Previous SIP installments"
                                                fontFamily="e-primary-font-inter  e-text-eerie-black mb-3"
                                                fontSize="e-font-14" />
                                            {
                                                (sipDetail.previous_installments || []).slice(0, viewMore ? sipDetail.previous_installments.length : 4).map((item, index) => (
                                                    <TimelineCard type={1}
                                                        data={item}
                                                        index={index}
                                                        dataLength={sipDetail.previous_installments.length > 4 ? viewMore ? sipDetail.previous_installments.length : 4 : sipDetail.previous_installments.length} />
                                                ))
                                            }
                                        </div>
                                    }

                                    {
                                        tabIndex !== 2 && (sipDetail.previous_installments || []).length > 4 &&
                                        <div className="mt-2">
                                            <TextButton name={viewMore ? "View less" : "View more"}
                                                type={3}
                                                iconClassName={viewMore ? "transform-rotate-min-180" : ""}
                                                onClick={_handleToggleViewMore} />
                                        </div>
                                    }

                                </div>
                                :
                                <>
                                    <div className='e-border-1px-white-marble e-border-radius-24 p-3'>
                                        <div className="e-bg-cultured e-border-radius-16 padding-12px-all mb-3">
                                            <div className={`d-flex gap-2 align-items-center`}>
                                                <img src={sipDetail.icon}
                                                    width={32}
                                                    height={32}
                                                    className="object-fit-contain e-border-radius-8 e-bg-white p-1"
                                                    draggable="false"
                                                    alt="fund image" />
                                                <h3 className="e-text-charleston-green e-font-10 e-alt-font-poppins e-font-weight-400 line-height-14px margin-12px-bottom mb-0">
                                                    {sipDetail.name}
                                                </h3>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <Chip type={2} name={sipDetail.status} className={sipDetail.is_active ? "e-text-persian-green e-border-1px-persian-green" : "e-border-1px-manhattan-red e-text-manhattan-red"} />
                                                {
                                                    selectedSIP.show_detail && tabIndex === 1 &&
                                                    <div className="position-relative">
                                                        <div className="d-inline-block" onClick={() => setShowSIPActions(true)}>
                                                            <img src={require("../../Assets/Images/3-dots.svg").default}
                                                                alt="3 dots menu"
                                                                className='cursor-pointer'
                                                                width={16}
                                                                height={16}
                                                                draggable="false"
                                                                onClick={() => { }} />
                                                        </div>
                                                        {
                                                            showSIPActions &&
                                                            <>
                                                                <OverLay isOpen={showSIPActions} onClose={_handleToggleSIPActions} />
                                                                <div className="d-flex flex-column gap-3 z-index-99 position-absolute top-100 end-0 e-bg-white e-border-radius-16 p-3">
                                                                    <span className='d-flex gap-2 align-items-center  text-nowrap cursor-pointer me-5 pe-5 e-text-charleston-green e-font-12 e-alt-font-poppins e-font-weight-500 line-height-20px'
                                                                        onClick={_handleEditSIPModal}>
                                                                        <Icon icon={"edit-sip"} size={18} />
                                                                        Edit SIP
                                                                    </span>
                                                                    <span className='d-flex gap-2 align-items-center  text-nowrap cursor-pointer me-5 pe-5 e-text-charleston-green e-font-12 e-alt-font-poppins e-font-weight-500 line-height-20px'
                                                                        onClick={_handleCancelModal}>
                                                                        <Icon icon={"cancel-sip"} size={18} />
                                                                        Cancel SIP
                                                                    </span>
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                }
                                            </div>

                                            {
                                                sipDetail.is_active === false &&
                                                <>
                                                    <div className="d-flex flex-column gap-12px margin-12px-bottom mt-3">
                                                        <div className="d-flex justify-content-between align-items-start">
                                                            <span className="e-text-onyx  e-primary-font-inter  e-font-12 e-font-weight-400 line-height-20px">
                                                                Total Invested
                                                            </span>
                                                            <span className="e-text-eerie-black e-primary-font-inter  e-font-12 e-font-weight-600 line-height-22px">
                                                                {sipDetail.amount_text}
                                                            </span>
                                                        </div>
                                                        <div className="d-flex justify-content-between align-items-start">
                                                            <span className="e-text-onyx  e-primary-font-inter  e-font-12 e-font-weight-400 line-height-20px">
                                                                Units Purchased
                                                            </span>
                                                            <span className="e-text-eerie-black e-primary-font-inter  e-font-12 e-font-weight-600 line-height-22px">
                                                                {selectedSIP.units}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <p className="e-border-radius-18 padding-12px-lr  padding-2px-tb e-bg-white-marble e-text-html-css-gray  e-primary-font-inter  e-font-12 e-font-weight-500 line-height-20px mb-0">
                                                        Showing amount and units purchased via this SIP
                                                    </p>
                                                </>
                                            }

                                            {
                                                sipDetail.status === "Cancellation in progress" &&
                                                <>
                                                    <p className='mt-3 e-text-charleston-green  e-primary-font-inter  e-font-10 e-font-weight-400 line-height-16px margin-12px-bottom'>
                                                        Your SIP cancellation is being processed, If this was a mistake, you can revert it below.
                                                    </p>

                                                    <p className="e-border-radius-18 padding-12px-lr  padding-2px-tb e-bg-white-marble e-text-html-css-gray  e-primary-font-inter  e-font-12 e-font-weight-500 line-height-20px margin-12px-bottom">
                                                        Showing amount and units purchased via this SIP
                                                    </p>

                                                    <PrimaryButton name="Undo Cancellation"
                                                        className="col-7 e-font-12 padding-12px-tb e-border-radius-10"
                                                        onPress={() => { }} />
                                                </>
                                            }
                                        </div>

                                        {
                                            sipDetail.is_active === false &&
                                            <p className="mb-3 e-border-radius-4 px-2 py-2 e-bg-digital-lavender e-text-charleston-green e-primary-font-inter  e-font-10 e-font-weight-400 line-height-16px">
                                                Your SIP has been stopped and no further payments will be deducted. All your past investments remain active and will continue to grow.
                                            </p>
                                        }

                                        <div>
                                            <SectionTitle title="Fund details"
                                                fontFamily="e-primary-font-inter  e-text-eerie-black "
                                                fontSize="e-font-14" />

                                            {
                                                (sipDetail.fund_details || []).map((fund, index) => (
                                                    <div className={`mt-2 e-border-bottom-1px-sparkling-silver pb-3 `} key={index}>
                                                        <div className={`${tabIndex !== 1 ? "cursor-pointer" : ""} d-flex gap-1 align-items-center `} onClick={() => _handleShowFundDetail(fund.mf_id)}>
                                                            <img src={fund.icon}
                                                                width={32}
                                                                height={32}
                                                                className="object-fit-contain e-border-radius-8 e-bg-white p-1"
                                                                draggable="false"
                                                                alt="fund image" />
                                                            <h6 className="e-ellipse flex-fill e-text-charleston-green e-font-12-lg-res e-font-14 e-alt-font-poppins e-font-weight-400 line-height-20px mb-0">
                                                                {fund.name}
                                                            </h6>
                                                            {
                                                                tabIndex === 3 &&
                                                                <Icon icon={"arrow-right-allocation"}
                                                                    className={`${selectedFundId === fund.mf_id ? "transform-rotate-min-90" : "transform-rotate-90"} ms-auto transition`}
                                                                    size={16} />
                                                            }
                                                        </div>

                                                        {
                                                            tabIndex === 3 && selectedFundId === fund.mf_id &&
                                                            <>
                                                                <div className="d-flex justify-content-between margin-12px-bottom margin-12px-top">
                                                                    <div className="col-auto d-flex flex-column">
                                                                        <span className="e-text-dark-heather  e-font-12  e-primary-font-inter e-font-weight-400 line-height-22px">
                                                                            Amount
                                                                        </span>
                                                                        <span className=" e-text-chinese-black e-font-12  e-primary-font-inter e-font-weight-600 line-height-22px">
                                                                            {fund.amount_text}
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-auto d-flex flex-column text-end">

                                                                        <span className="e-text-dark-heather  e-font-12  e-primary-font-inter e-font-weight-400 line-height-22px">
                                                                            Nav
                                                                        </span>
                                                                        <span className=" e-text-chinese-black e-font-12  e-primary-font-inter e-font-weight-600 line-height-22px">
                                                                            {fund.nav || '-'}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex justify-content-between">
                                                                    <div className="col-auto d-flex flex-column">
                                                                        <span className="e-text-dark-heather  e-font-12  e-primary-font-inter e-font-weight-400 line-height-22px">
                                                                            Allocation date
                                                                        </span>
                                                                        <span className=" e-text-chinese-black e-font-12  e-primary-font-inter e-font-weight-600 line-height-22px">
                                                                            {fund.allocation_date || "-"}
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-auto d-flex flex-column text-end">
                                                                        <span className="e-text-dark-heather  e-font-12  e-primary-font-inter e-font-weight-400 line-height-22px">
                                                                            Transaction ID
                                                                        </span>
                                                                        <span className=" e-text-chinese-black e-font-12  e-primary-font-inter e-font-weight-600 line-height-22px">
                                                                            {fund.transaction_id || "-"}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                {/* Transaction status */}
                                                                {
                                                                    fund?.fund_timeline?.length !== 0 &&
                                                                    <div className='e-border-top-1px-sparkling-silver mt-3 pt-3'>
                                                                        <SectionTitle title="Transaction status"
                                                                            fontFamily="e-primary-font-inter  e-text-eerie-black mb-3"
                                                                            fontSize="e-font-14" />

                                                                        {
                                                                            (fund.fund_timeline || []).map((item, index) => (
                                                                                <TimelineCard type={2}
                                                                                    data={item}
                                                                                    index={index}
                                                                                    dataLength={fund.fund_timeline.length} />
                                                                            ))
                                                                        }
                                                                    </div>
                                                                }
                                                            </>
                                                        }
                                                    </div>
                                                ))
                                            }

                                        </div>

                                        {/* Upcoming SIP */}
                                        {
                                            sipDetail.is_active && tabIndex === 1 &&
                                            <div className='mt-3'>
                                                <SectionTitle title="Upcoming SIPs"
                                                    fontFamily="e-primary-font-inter  e-text-eerie-black mb-2"
                                                    fontSize="e-font-14" />

                                                <div className="d-flex gap-2 align-items-center">
                                                    <Icon icon={"calendar-sip"}
                                                        size={24} />
                                                    <span className='e-text-onyx e-font-12-res e-font-14 e-primary-font-inter e-font-weight-400 line-height-20px mb-0'>
                                                        {sipDetail?.upcoming_sip?.full_date || '-'}
                                                    </span>
                                                </div>

                                            </div>
                                        }

                                        {/* Previous SIP installments */}
                                        {
                                            tabIndex !== 2 && (sipDetail.previous_installments && sipDetail.previous_installments?.length) > 0 &&
                                            <div className="mt-3">
                                                <SectionTitle title="Previous SIP installments"
                                                    fontFamily="e-primary-font-inter  e-text-eerie-black mb-3"
                                                    fontSize="e-font-14" />
                                                {
                                                    (sipDetail.previous_installments || []).slice(0, viewMore ? sipDetail.previous_installments.length : 4).map((item, index) => (
                                                        <TimelineCard type={1}
                                                            data={item}
                                                            index={index}
                                                            dataLength={sipDetail.previous_installments.length > 4 ? viewMore ? sipDetail.previous_installments.length : 4 : sipDetail.previous_installments.length} />
                                                    ))
                                                }
                                            </div>
                                        }

                                        {
                                            tabIndex !== 2 && (sipDetail.previous_installments || []).length > 4 &&
                                            <div className="mt-2">
                                                <TextButton name={viewMore ? "View less" : "View more"}
                                                    type={3}
                                                    iconClassName={viewMore ? "transform-rotate-min-180" : ""}
                                                    onClick={_handleToggleViewMore} />
                                            </div>
                                        }

                                    </div>
                                </>
                            :
                            <DetailPreviewCard title={"Pick an SIP to get started"}
                                description=" Detailed insights will appear here once you choose a SIP." />
                }
            </>
        )
    };

    return (
        <>
            <div className="row min-h-100vh pb-4 pb-sm-5 e-bg-lotion px-4 px-sm-5 ps-lg-4 pe-lg-0 padding-26px-top e-border-radius-TL-BL-24px" >
                {/* breadcrumbs */}

                <div className="col-lg-11 px-0">
                    <div className="row justify-content-between margin-32px-bottom">
                        <div className="col-md-8">
                            <div className="d-flex justify-content-between">
                                <BreadCrumbs data={BREADCRUMBS} />

                                <div className={`position-relative ${loading ? "pe-none opacity-50" : ""}`} id="orders-filter">
                                    <FilterCard filterText={`${filterPortfolioFor?.label} ${filterInvestmentType.id && filterInvestmentType.id !== null ? ", +1" : ""}`}
                                        handleOpenFilterModal={_handlePortfolioFilterModal} />
                                    {
                                        toggleFilterModal &&
                                        <>
                                            <OverLay isOpen={toggleFilterModal} onClose={_handleToggleFilter} />
                                            <PortfolioFilterModal
                                                noInvestmentTypeFilter={tabIndex === 2}
                                                filterOptionsPortfolioFor={filterOptionsPortfolioFor}
                                                filterOptionsInvestment={FILTER_INVESTMENT_TYPES}
                                                selectedFilterPortfolioFor={filterPortfolioFor}
                                                selectedFilterInvestmentType={filterInvestmentType}
                                                onClick={_handleCloseFilterModal}
                                                handleSelectedFilters={_handleApplyFilters} />
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row row-gap-4 ">
                        <div className="col-md-8">
                            <div className="d-flex justify-content-between">
                                {
                                    SIP_TAB.map((data, key) => (
                                        <CustomTab key={key}
                                            className="flex-fill text-center"
                                            type={4}
                                            tabData={data}
                                            tabIndex={tabIndex}
                                            handleChange={_handleTabChange} />
                                    ))
                                }
                            </div>

                            {
                                (tabIndex === 1 || tabIndex === 2) &&
                                <div className="e-border-radius-24 e-bg-egyptian-blue p-1 mt-4">
                                    <div className="e-bg-white e-border-radius-24 p-3">
                                        <p className="e-text-sonic-silver e-font-12-res e-font-14 e-primary-font-inter e-font-weight-600 mb-sm-2">
                                            Total Monthly SIP Amount
                                        </p>
                                        <span className={`e-text-eerie_black e-font-14-res e-primary-font-inter e-font-weight-700 e-font-28 line-height-28px`}>
                                            {totalMonthlySIPAmount}
                                        </span>
                                    </div>
                                </div>
                            }

                            <div className='d-flex justify-content-between align-items-center my-sm-4 my-3'>
                                <SectionTitle title={tabIndex === 1 || tabIndex === 2 ? "Active SIPs" : tabIndex === 3 ? "Executed SIPs" : "Cancelled SIPs"}
                                    fontFamily=" e-primary-font-inter e-text-eerie-black e-font-20" />
                                <Icon icon={isCardView ? "list-view" : "card-view"}
                                    className="cursor-pointer w-24px width-16px-res"
                                    onClick={_handleChangeSIPListView} />
                            </div>

                            <div>
                                {
                                    loading ?
                                        <div className="min-h-100vh text-center mt-5" >
                                            <img src={Loader}
                                                draggable="false"
                                                alt="loader" />
                                        </div>
                                        :
                                        <>
                                            {/* active sip card */}
                                            <div className={`row pt-4 mt-2 pb-2 ${isCardView ? " row-gap-4 " : " row-gap-3 "}`}>

                                                {
                                                    activeSIPList.length !== 0 ? (
                                                        <>
                                                            {
                                                                activeSIPList.map((data, key) => (
                                                                    <>
                                                                        <div key={key}
                                                                            className={`${isCardView ? "col-sm-6 col-12" : "col-12"}`}>
                                                                            <ActiveSIPCard key={key}
                                                                                type={tabIndex}
                                                                                data={data}
                                                                                isCardView={isCardView}
                                                                                selectedSIP={selectedSIP}
                                                                                onClickCard={() => _handleSelectSIP(data)} />
                                                                        </div>
                                                                    </>
                                                                ))
                                                            }
                                                            {
                                                                totalPageActive > 1 &&
                                                                <div className="e-display-flex justify-content-center e-gap-0-16 pt-4 mt-2 " >
                                                                    <Pagination
                                                                        initialPage={pageNumberActive - 1}
                                                                        nextButtonLabel={<img src={NextIcon} draggable="false" alt="Next" />}
                                                                        prevButtonLabel={<img src={NextIcon} draggable="false" alt="Next" />}
                                                                        itemsPerPage={ITEMS_PER_PAGE}
                                                                        totalPage={totalPageActive}
                                                                        onChange={_handlePaginationActive}
                                                                        showFirstLastPages={true} />
                                                                </div >
                                                            }
                                                        </>
                                                    ) : (
                                                        <EmptyScreen
                                                            img={EmptySIP}
                                                            title={tabIndex === 1 || tabIndex === 2 ? "No active SIPs!" : tabIndex === 3 ? "No executed SIPs!" : "No cancelled SIPs!"}
                                                            description="Start building your wealth effortlessly with SIPs - Explore funds and invest in simple steps." />
                                                    )
                                                }



                                            </div>

                                        </>
                                }
                            </div>



                        </div>
                        {
                            tabIndex !== 2 &&
                            <div className="col-md-4 d-md-block d-none" id="detailed-fund-view">
                                <DetailsViewCard />
                            </div>
                        }
                    </div>
                </div>



                {
                    selectedSIP?.sip_id &&
                    <OffcanvasDetailViewModal title="SIP Detail">
                        <DetailsViewCard />
                    </OffcanvasDetailViewModal>
                }

                {/* cancel conformation modal  */}
                {
                    showCancelSIPModal &&
                    <SIPConfirmationModal
                        sipCancelReasons={sipCancelReasons}
                        cancelSip={_handleCancelActiveSIP}
                        onClose={() => setShowCancelSIPModal(false)} />
                }

                {/* edit sip modal */}
                {
                    showEditSIPModal &&
                    <EditSIPModal data={selectedSIP}
                        handleSuccess={_handleShowStatusModal}
                        onClose={() => setShowEditSIPModal(false)} />
                }

                {
                    showSIPStatusModal === "EDIT" || showSIPStatusModal === "CANCEL" &&
                    <KycStatusModal title={showSIPStatusModal === "EDIT" ? "Updated Successfully" : "Cancelled Successfully"}
                        description={showSIPStatusModal === "EDIT" ? "Your SIP has been edited. No further payments will be processed" : "SIP cancellation request has been submitted to Admin"}
                        buttonName="View Details"
                        image={require("../../Assets/Images/KYC/kyc-success.webp")}
                        type={2}
                        onCloseModal={_handleCloseStatusModal}
                        onButtonClick={_handleCloseStatusModal} />
                }
            </div >

            {/* footer  */}
            < Footer />
        </>
    )
}

export default SIPListing;